import React, { Component, Fragment } from 'react';
import { Card, TableContainer, Table, TableBody, TableHead, TableRow, TableCell, Box, Link, ListItem, ListItemIcon, ListItemText, CardContent, CardActions, Button } from '@material-ui/core';
import { AddCircleRounded, AddCircleOutlineRounded} from '@material-ui/icons';
import { connect } from 'react-redux';

import { read, utils, writeFile } from 'xlsx';
import Papa from 'papaparse';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import { toast } from 'react-toastify';

class FormTableTitle extends Component {
    state = {  }
    render() {
        const { title, color } = this.props;
        return (
            <Box p={2} className={(color ? color : "bgm-bluegray ")}>
                <h4 className="text-center c-white"><i>{title}</i></h4>
            </Box>
        );
    }
}
            
export class FormTableTh extends Component {
    state = {  }
    render() {
        const { showTVA, isTVAExempt } = this.props;
        return (
           
            <thead>
                <TableRow>
                    <TableCell style={{minWidth:'500px'}}>Produit</TableCell>
                    <TableCell style={{minWidth:'120px'}}>Quantité</TableCell>
                    <TableCell style={{minWidth:'150px'}}>Prix Unitaire</TableCell>
                    {showTVA && <TableCell style={{minWidth:'100px'}}>TVA (%)</TableCell>}
                    <TableCell style={{minWidth:'200px'}}>{!showTVA || isTVAExempt ? 'TOTAL HT' : 'TOTAL TTC'}</TableCell>
                </TableRow>
            </thead>
        );
    }
}
                    
export class ReaTableTh extends Component {
    state = {  }
    render() {
        return (
           
            <TableHead>
                <TableRow>
                    <TableCell style={{minWidth:'300px'}}>Produit</TableCell>
                    <TableCell style={{minWidth:'150px'}}>Quantité</TableCell>
                </TableRow>
            </TableHead>
                    
        );
    }
}

export class OrderTableTh extends Component {
    state = {  }
    render() {

        return (
           
            <TableHead>
                <TableRow>
                    <TableCell style={{minWidth:'300px'}}>Magasin</TableCell>
                    <TableCell style={{minWidth:'150px'}}>Quantité</TableCell>
                </TableRow>
            </TableHead>
                    
        );
    }
}



// Colonnes du fichier d'import pouvant contenir la référence produit.
// L'ordre attendu est [Product Name, ID product, Quantity, Total Price], mais les
// anciens templates plaçaient la référence en première colonne.
const REF_COLUMN_CANDIDATES = [1, 0];
const QUANTITY_COLUMN = 2;
const TOTAL_PRICE_COLUMN = 3;

const normalizeCell = (value) =>
    value === undefined || value === null ? "" : String(value).trim();

const normalizeRef = (value) => normalizeCell(value).toUpperCase();

// Marque une ancienne référence portée par plusieurs produits : l'import la refuse plutôt que
// d'en choisir un en silence.
const AMBIGUOUS_REF = Object.freeze({ ambiguous: true });

class FormLayout extends Component {
    //state = {  }
    state = {
        open: false,
        data: [],
      };

      handleClickOpen = () => {
        this.setState({ open: true });
      };

      handleDownloadTemplate = () => {
        const header = ['Product Name', 'ID product', 'Quantity', 'Total Price'];
        const sampleRow = ['Panneau solaire 100W', 'PAN_VIC_1R77YB8', 10, 150000];
        const worksheet = utils.aoa_to_sheet([header, sampleRow]);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Template');
        writeFile(workbook, 'template_import_stock.xlsx');
      };

      handleRemoveList = () =>{
            this.setState({ data: [] });
      };
      handleClose = () => {
        this.setState({  open: false  });
      };

      buildRefIndex = () => {
        const { PRODUCTS } = this.props;
        const index = new Map();
        if (PRODUCTS) {
            const products = Object.values(PRODUCTS);
            products.forEach((product) => {
                if (product && product.ref) {
                    index.set(normalizeRef(product.ref), product);
                }
            });
            // Anciennes références du compte (fiches absorbées par la fusion product-mix),
            // servies par storehouse dans legacy_refs : un fichier préparé avant la fusion les
            // porte encore. Indexées en second, sans jamais écraser une référence principale ;
            // une ancienne référence partagée par deux produits différents devient ambiguë.
            const legacyKeys = new Set();
            products.forEach((product) => {
                if (!product || !Array.isArray(product.legacy_refs)) {
                    return;
                }
                product.legacy_refs.forEach((legacyRef) => {
                    const key = normalizeRef(legacyRef);
                    if (!key) {
                        return;
                    }
                    if (!index.has(key)) {
                        index.set(key, product);
                        legacyKeys.add(key);
                    } else if (legacyKeys.has(key)) {
                        const current = index.get(key);
                        if (current !== AMBIGUOUS_REF && current.id !== product.id) {
                            index.set(key, AMBIGUOUS_REF);
                        }
                    }
                });
            });
        }
        return index;
      };

      // Le template a changé d'ordre de colonnes au fil du temps : on retient la colonne
      // qui reconnaît le plus de références du catalogue plutôt qu'une position figée.
      detectRefColumn = (rows, refIndex) => {
        let refColumn = REF_COLUMN_CANDIDATES[0];
        let bestScore = -1;
        REF_COLUMN_CANDIDATES.forEach((column) => {
            const score = rows.filter((row) => refIndex.has(normalizeRef(row[column]))).length;
            if (score > bestScore) {
                bestScore = score;
                refColumn = column;
            }
        });
        return refColumn;
      };

      buildRow = (row, refColumn, nameColumn, refIndex) => {
        const ref = normalizeRef(row[refColumn]);
        const found = refIndex.get(ref);
        const ambiguous = found === AMBIGUOUS_REF;
        const product = ambiguous ? undefined : found;
        const quantity = Number(row[QUANTITY_COLUMN]);
        const totalPrice = Number(row[TOTAL_PRICE_COLUMN]);

        let error = "";
        if (ambiguous) {
            error = "Référence ambiguë (plusieurs produits)";
        } else if (!product) {
            error = "Référence introuvable dans le catalogue";
        } else if (!Number.isFinite(quantity) || quantity <= 0) {
            error = "Quantité invalide";
        } else if (!Number.isFinite(totalPrice) || totalPrice < 0) {
            error = "Prix total invalide";
        }

        const productName = product
            ? product.marque + "-" + product.name
            : normalizeCell(row[nameColumn]) || ref;

        return [productName, ref, quantity, totalPrice, error === "", product || {}, error];
      };

      handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = utils.sheet_to_json(sheet, { header: 1, blankrows: false });
          const dataTmp = jsonData
            .slice(1) // skip the header row
            .filter((row) => REF_COLUMN_CANDIDATES.some((column) => normalizeCell(row[column]) !== ""));

          const refIndex = this.buildRefIndex();
          const refColumn = this.detectRefColumn(dataTmp, refIndex);
          const nameColumn = refColumn === 0 ? 1 : 0;

          const dataConverted = dataTmp.map((row) => this.buildRow(row, refColumn, nameColumn, refIndex));
          const validCount = dataConverted.filter((row) => row[4]).length;

          if (dataConverted.length > 0 && validCount === 0) {
            toast.error("Aucune référence du fichier ne correspond au catalogue produit");
          }

          this.setState({ data: dataConverted });
          event.target.value = null;
        };
        reader.readAsArrayBuffer(file);
      };

      handleValidation = (index) => (event) => {
        const checked = event.target.checked;
        this.setState((prevState) => ({
          data: prevState.data.map((row, rowIndex) =>
            rowIndex === index ? [...row.slice(0, 4), checked, ...row.slice(5)] : row
          ),
        }));
      };

      handleSubmit = () => {
        const selected = this.state.data.filter((row) => row[4]);
        if (selected.length === 0) {
            toast.error("Sélectionnez au moins un produit valide avant d'envoyer");
            return;
        }
        this.props.onClickForCSVUpload(this.state.data)
        this.handleClose();
      };
    render() {
        const { title, color, children, rea, order, colSpan, onClick, disabled, showTVA, isTVAExempt } = this.props;
        return (
            <Box p={1}>
                {title &&
                    <FormTableTitle title={title} color={color} />
                }
                
                <TableContainer>
                    <Table className="table table-striped table-bordered">
                        { rea &&
                            <ReaTableTh />
                        }
                        {!rea && !order &&
                            <FormTableTh showTVA={showTVA} isTVAExempt={isTVAExempt} />
                        }
                        {order &&
                            <OrderTableTh />
                        }
                        
                        <TableBody>
                            {children ||
                            <Fragment>
                                {this.props.createAddForm}
                                <TableRow className="plus-btn" onClick={onClick}>
                                    <TableCell colSpan={colSpan}>
                                        <Link color="secondary"> 
                                            {/* <AddCircleOutlineRounded />
                                            <span>Ajouter un produit</span>  */}
                                            {/* <ListItem>
                                                <ListItemIcon>
                                                    <AddCircleOutlineRounded />
                                                </ListItemIcon>
                                                <ListItemText primary="Ajouter un produit" />
                                            </ListItem> */}
                                            <Button color="secondary" startIcon={<AddCircleRounded />} disabled={disabled}>
                                                <b>Ajouter un produit</b>
                                            </Button>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                                <TableRow className="plus-btn" onClick={this.handleClickOpen}>
                                    <TableCell colSpan={colSpan}>
                                        <Link color="secondary">
                                            <Button color="secondary" startIcon={<AddCircleOutlineRounded />} disabled={disabled}>
                                                <b>Ajouter une liste de produit par CSV</b>
                                            </Button>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            </Fragment>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="md">
          <DialogTitle>Télécharger un fichier XLS</DialogTitle>
          <DialogContent>
            <input
              type="file"
              id="xls-file-input"
              accept=".xlsx,.xls"
              onChange={this.handleFileUpload}
              style={{ display: 'none' }}
            />
            <label htmlFor="xls-file-input">
              <Button
                variant="contained"
                color="primary"
                component="span"
              >
                Choisir un fichier
              </Button>
            </label>
            <Box mt={2}>
              <Button variant="outlined" color="secondary" onClick={this.handleDownloadTemplate}>
                Télécharger le template
              </Button>
            </Box>
            {this.state.data.length > 0 &&
              <Box mt={2}>
                <span>
                  {this.state.data.filter((row) => row[4]).length} produit(s) sélectionné(s) sur {this.state.data.length} ligne(s) du fichier
                </span>
              </Box>
            }
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell>ID product</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Total Price</TableCell>
                    <TableCell>Valide</TableCell>
                    <TableCell>Motif</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.data.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row[0]}</TableCell>
                      <TableCell>{row[1]}</TableCell>
                      <TableCell>{row[2]}</TableCell>
                      <TableCell>{row[3]}</TableCell>
                      <TableCell>
                        <Checkbox
                          checked={row[4]}
                          disabled={row[6] !== ""}
                          onChange={this.handleValidation(index)}
                        />
                      </TableCell>
                      <TableCell style={{ color: '#d32f2f' }}>{row[6]}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
          <Button onClick={this.handleRemoveList} color="primary">
              Supprimer liste
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Annuler
            </Button>
            <Button onClick={this.handleSubmit} color="primary">
              Envoyer
            </Button>
          </DialogActions>
        </Dialog>
            </Box>
        );
    }
}


export default FormLayout;
